import React from 'react';

import {createRoutesFromElements, createHashRouter, Route} from 'react-router-dom';

import * as APPDATA from '@/constants/pcConstAppData';
import {WifiListContextProvider} from '@/contexts/WifiListContext';

import AdvanceSetupMenu from './advancedSetup/generalSetup/AdvanceSetupMenus';
import AdvancedSetupExplorer from './advancedSetupExplorer/AdvancedSetupExplorer';
import ManualHardwareCheck from './allhardwarevalue/AllHardwareValue';
import AutoProfileParameters from './autoProfile/parameters/AutoProfileParameters';
import AutoProfileSetup from './autoProfile/setup/AutoProfileSetup';
import AutoProfileStatus from './autoProfile/status/AutoProfileStatus';
import CalibrationHistory from './calibrationLoadCellSensor/calibrationLoadCellHistory/CalibrationHistory';
import CalibrationLoadCellSensor from './calibrationLoadCellSensor/CalibrationLoadCellSensor';
import CalibrationLoadCellSensorWizard from './calibrationLoadCellSensor/components/CalibrationLoadCellSensorWizard';
import CheckScales from './calibrationLoadCellSensor/components/CheckScales';
import CleaningWizard from './cleaningWizard/CleaningWizard';
import CompleteRinse from './cleaningWizard/cleaningWizard/CompleteRinse';
import StatusRinse from './cleaningWizard/cleaningWizard/StatusRinse';
import CycleHistoryPage from './cycleHistory/CycleHistoryPage';
import LogMenuPage from './cycleHistory/LogMenuPage';
import ErrorPage from './error/ErrorPage';
import RemoteSupportPage from './error/RemoteSupportPage';
import ShutdownPage from './error/ShutdownPage';
import ErrorBoundaryProvider from './ErrorBoundaryProvider';
import HomeScreen from './homeScreen/HomeScreen';
import InfoPage from './infopage/InfoPage';
import MainContainer from './main/MainContainer';
import ManualProfile from './manualProfile/ManualProfile';
import ManualProfileExplorer from './manualProfile/manualProfileExplorer/ManualProfileExplorer';
import ReleaseNotes from './releaseNotes/ReleaseNotes';
import StatusPage from './status/StatusPage';
import DeviceSetting from './systemSetting/deviceSetting/DeviceSetting';
import TimezoneSetting from './systemSetting/deviceSetting/TimezoneSetting';
import DisplaySetting from './systemSetting/displaySetting/DisplaySetting';
import GeneralSetting from './systemSetting/generalSetting/GeneralSetting';
import PressureSetting from './systemSetting/pressureSetting/PressureSetting';
import VolumeThresholdSetting from './systemSetting/volumeThresholdSetting/VolumeThresholdSetting';
import WifiSetting from './systemSetting/wifiSetting/WifiSetting';
import UsbFileList from './usbFileList/UsbFileList';
import USBFolderList from './usbFolderList/UsbFolderList';
import USBFolderListSystemLog from './usbFolderList/UsbFolderListSystemLog';
import VolumeSensorGraph from './volumeSensorChart/VolumeSensorChart';
import WarmingUp from './warmingUp/WarmingUp';

const Router = (loaders = {}) =>
  createHashRouter(
    createRoutesFromElements(
      <Route
        loader={loaders[APPDATA.HOME_SCREEN_ADDRESS]}
        path="/"
        element={<MainContainer />}
      >
        <Route
          exact
          path={APPDATA.HOME_SCREEN_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<HomeScreen />}
        />

        <Route
          path={APPDATA.ALL_HARDWARE_VALUE_ADDRESS.replace('#', '')}
          element={<ManualHardwareCheck />}
        />

        <Route
          path={APPDATA.ERROR_PAGE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<ErrorPage />}
        />

        <Route
          path={APPDATA.REMOTE_SUPPORT_PAGE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<RemoteSupportPage />}
        />

        <Route
          path={APPDATA.SHUTDOWN_PAGE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<ShutdownPage />}
        />

        <Route
          path={APPDATA.WARMING_UP_ADRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<WarmingUp />}
        />

        <Route
          path={APPDATA.RELEASE_NOTES_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<ReleaseNotes />}
        />

        <Route
          path={APPDATA.STATUS_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<StatusPage />}
        />

        <Route
          path={APPDATA.INFO_AND_SUPPORT_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<InfoPage />}
        />

        <Route
          path={APPDATA.AUTO_PROFILE_SETUP.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<AutoProfileSetup />}
        />

        <Route
          path={APPDATA.AUTO_PROFILE_STATUS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<AutoProfileStatus />}
        />

        <Route
          // loader={loaders[APPDATA.VOLUME_SENSOR_CHART_ADDRESS]}
          path={APPDATA.VOLUME_SENSOR_CHART_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<VolumeSensorGraph />}
        />

        <Route
          path={APPDATA.AUTO_PROFILE_PARAMETERS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<AutoProfileParameters />}
        />

        <Route
          path={APPDATA.ADVANCE_SETUP_EXPLORER.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<AdvancedSetupExplorer />}
        />

        <Route
          path={APPDATA.ADVANCE_SETUP_GENERAL_SETUP.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<AdvanceSetupMenu />}
        />

        <Route
          path={APPDATA.MANUAL_PROFILE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<ManualProfile />}
        />

        <Route
          path={APPDATA.MANUAL_PROFILE_EXPLORER_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<ManualProfileExplorer />}
        />

        <Route
          path={APPDATA.CLEANING_WIZARD_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CleaningWizard />}
        />

        <Route
          path={APPDATA.RINSE_WIZARD_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<StatusRinse />}
        />

        <Route
          path={APPDATA.COMPLETE_RINSE_WIZARD_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CompleteRinse />}
        />

        <Route
          path={APPDATA.CYCLE_HISTORY_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CycleHistoryPage />}
        />

        <Route
          path={APPDATA.SYSTEM_LOGS_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<LogMenuPage />}
        />

        <Route
          path={APPDATA.USB_FILE_LIST_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<UsbFileList />}
        />

        <Route
          path={APPDATA.USB_FOLDER_LIST_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<USBFolderList />}
        />

        <Route
          path={APPDATA.USB_FOLDER_LIST_ADDRESS_SYSTEM_LOG.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<USBFolderListSystemLog />}
        />

        <Route
          path={APPDATA.DEVICE_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<DeviceSetting />}
        />

        <Route
          path={APPDATA.TIMEZONE_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<TimezoneSetting />}
        />

        <Route
          path={APPDATA.DISPLAY_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<DisplaySetting />}
        />

        <Route
          path={APPDATA.GENERAL_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<GeneralSetting />}
        />

        <Route
          path={APPDATA.PRESSURE_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<PressureSetting />}
        />

        <Route
          path={APPDATA.VOLUME_THRESHOLD_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<VolumeThresholdSetting />}
        />

        <Route
          path={APPDATA.WIFI_SETTING_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={
            <WifiListContextProvider>
              <WifiSetting />
              {/* <ComponentContainer /> */}
            </WifiListContextProvider>
          }
        />

        <Route
          path={APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CalibrationLoadCellSensor />}
        />

        <Route
          path={APPDATA.CALIBRRATION_HISTORY_ADRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CalibrationHistory />}
        />

        <Route
          path={APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CHECK_SCALE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CheckScales />}
        />

        <Route
          path={APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CALIBRATE_SCALE_ADDRESS.replace('#', '')}
          ErrorBoundary={ErrorBoundaryProvider}
          element={<CalibrationLoadCellSensorWizard />}
        />
      </Route>,
    ),
  );

export default Router;
